import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { toast } from '../toaster-provider'
import type { AxiosError } from 'axios'

export function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 0,
      },
      mutations: {},
    },
  })

  // Global error handling for queries
  queryClient.getQueryCache().subscribe((event) => {
    if (event.type === 'updated' && 'error' in event.query) {
      const error = event.query.error as AxiosError
      if (error.response?.status && error.response.status !== 401) {
        const errorMessage =
          (typeof error.response.data === 'object' &&
          error.response.data !== null &&
          'message' in error.response.data
            ? (error.response.data as { message?: string }).message
            : undefined) || error.message
        console.error('Non-Auth Query Error:', errorMessage)
        toast.error(`Error: ${errorMessage}`)
      }
    }
  })

  // Global error handling for mutations
  queryClient.getMutationCache().subscribe((event) => {
    if (event.type === 'updated' && 'error' in event.mutation) {
      const error = event.mutation.error as AxiosError

      if (error.response?.status && error.response.status !== 401) {
        const errorMessage =
          (typeof error.response.data === 'object' &&
          error.response.data !== null &&
          'message' in error.response.data
            ? (error.response.data as { message?: string }).message
            : undefined) || error.message
        console.error('Non-Auth Query Error:', errorMessage)
        toast.error(`Error: ${errorMessage}`)
      }
    }
  })

  return {
    queryClient,
  }
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode
  queryClient: QueryClient
}) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
